<template>
  <button
    class="image-toggle"
    @click="imageVisibility.toggle()"
    :aria-label="imageVisibility.showImages ? 'Hide images' : 'Show images'"
    :title="imageVisibility.showImages ? 'Hide images' : 'Show images'"
  >
    <!-- Eye icon (images visible - click to hide) -->
    <svg
      v-if="imageVisibility.showImages"
      class="image-toggle__icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
    <!-- Eye-off icon (images hidden - click to show) -->
    <svg
      v-else
      class="image-toggle__icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"></path>
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"></path>
      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"></path>
      <line x1="1" y1="1" x2="23" y2="23"></line>
    </svg>
  </button>
</template>

<script>
import { imageVisibility } from '@/utils/imageVisibility';

export default {
  name: 'ImageVisibilityToggle',
  data() {
    return {
      imageVisibility
    };
  }
};
</script>

<style scoped>
.image-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md, 8px);
  cursor: pointer;
  color: var(--text-secondary);
  transition: all 150ms ease;
}

.image-toggle:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
  border-color: var(--border-strong);
}

.image-toggle:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--bg-primary), 0 0 0 4px var(--color-primary, #00897b);
}

.image-toggle:active {
  transform: scale(0.95);
}

.image-toggle__icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
</style>
